import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { EXPERIMENTS_SWITCH } from 'redux/actionTypes/experiments';
import reloadExperimentInfo from './reloadExperimentInfo';
var switchExperiment = function switchExperiment(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: EXPERIMENTS_SWITCH
            });
            _context.next = 3;
            return dispatch(reloadExperimentInfo(experimentId));
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default switchExperiment;